<p>admin-log works!</p>
